export default __webpack_public_path__ + "static/total-do-178153f78ea0990245935631c575a805470d29433878ecc7013fbcdd936a13c2.png";